import * as React from 'react';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListBranchDebugSummaryRow = ({
  dataTestId,
  label,
  value
}) => {
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "p-x-5",
    children: [/*#__PURE__*/_jsx(UIGridItem, {
      size: 4,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: label
      })
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: 8,
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: value
        })
      })
    })]
  });
};
export default ListBranchDebugSummaryRow;